import { HostActions, CDL_V3_EVENT } from '@makemydeal/dr-activities-change-vehicle';
import * as openDealActionCreators from '@makemydeal/dr-activities-open-deal';

export const hostActions: HostActions = {
    navigateToDashboard: openDealActionCreators.toggleChangeVehicleEditMode,
    switchVehicle: openDealActionCreators.switchVehicle,
    forwardCDLEvent: (cdlPayload: any) => ({
        type: CDL_V3_EVENT,
        payload: cdlPayload
    })
};
